import React from 'react';
import _ from 'lodash';

const CustomHTMLWidget = (props) => {
    const { widgetData } = props;

    return (
        <div dangerouslySetInnerHTML={{ __html: _.get(widgetData, '[0].value', '') }} />
    );
};

export default CustomHTMLWidget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/CustomHTMLWidget.jsx
 **/